(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comunidad"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-comunidad]').forEach(function (raiz) {
      /* Flechas de la tira: avanzan lo que se ve y se apagan en los extremos. */
      var tira = raiz.querySelector('[data-tira]');
      if (tira) {
        var pista = tira.querySelector('[data-tira-pista]');
        var prev = tira.querySelector('[data-tira-prev]');
        var next = tira.querySelector('[data-tira-next]');
        var estado = function () {
          prev.disabled = pista.scrollLeft <= 2;
          next.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2;
        };
        prev.addEventListener('click', function () { pista.scrollBy({ left: -pista.clientWidth * 0.8, behavior: 'smooth' }); });
        next.addEventListener('click', function () { pista.scrollBy({ left: pista.clientWidth * 0.8, behavior: 'smooth' }); });
        pista.addEventListener('scroll', estado, { passive: true });
        window.addEventListener('resize', estado);
        estado();
      }

      /* Los TikTok se reproducen solo mientras están en pantalla y nunca con movimiento reducido. */
      var videos = raiz.querySelectorAll('[data-tiktok-video]');
      if (!videos.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { e.target.preload = 'auto'; var p = e.target.play(); if (p && p.catch) p.catch(function () {}); }
          else e.target.pause();
        });
      }, { threshold: 0.35 });
      videos.forEach(function (v) { io.observe(v); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-libro-reclamaciones"]) return;
  try {
    
  (function () {
    var form = document.querySelector('[data-libro-form]');
    if (!form) return;

    // La fecha de la hoja es la de Lima al momento de enviar, no la del caché de la página.
    var fechaLima = function () { return new Intl.DateTimeFormat('es-PE', { timeZone: 'America/Lima', day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date()); };
    var fecha = form.querySelector('[data-libro-fecha]');
    var fechaTexto = document.querySelector('[data-libro-fecha-texto]');
    var pintarFecha = function () { var f = fechaLima(); if (fecha) fecha.value = f; if (fechaTexto) fechaTexto.textContent = f; };
    pintarFecha();

    var endpoint = form.getAttribute('data-libro-endpoint');
    if (!endpoint) { form.addEventListener('submit', pintarFecha); return; } // vía Shopify: el formulario sigue su curso

    var general = form.querySelector('[data-libro-error]');
    var boton = form.querySelector('[data-libro-enviar]');
    var limpiar = function () {
      if (general) general.hidden = true;
      form.querySelectorAll('[data-libro-campo-error]').forEach(function (p) { p.remove(); });
      form.querySelectorAll('[aria-invalid="true"]').forEach(function (c) { c.removeAttribute('aria-invalid'); c.removeAttribute('aria-describedby'); });
    };
    var marcar = function (clave, texto) {
      var control = form.querySelector('[data-clave="' + clave + '"]');
      var campo = control && control.closest('.campo');
      if (!campo) return null;
      var p = document.createElement('p');
      p.className = 'campo__error'; p.id = 'err-' + control.id; p.setAttribute('data-libro-campo-error', '');
      p.textContent = texto;
      campo.appendChild(p);
      control.setAttribute('aria-invalid', 'true'); control.setAttribute('aria-describedby', p.id);
      return control;
    };
    var avisar = function (texto) {
      if (!general) return;
      general.querySelector('span').textContent = texto;
      general.hidden = false;
      general.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    var datos = function () {
      var d = {};
      form.querySelectorAll('[data-clave]').forEach(function (c) {
        var k = c.getAttribute('data-clave');
        if (c.type === 'radio') { if (c.checked) d[k] = c.value; }
        else if (c.type === 'checkbox') d[k] = c.checked;
        else d[k] = c.value.trim();
      });
      d.fecha_cliente = fechaLima();
      return d;
    };
    var exito = function (r) {
      var caja = document.createElement('div');
      caja.className = 'formulario__ok'; caja.setAttribute('role', 'status'); caja.tabIndex = -1;
      var t = document.createElement('p'); t.className = 'cuerpo cuerpo--medio';
      t.textContent = 'Tu hoja de reclamación N.º ' + r.codigo + ' quedó registrada; te mandamos una copia a tu correo.';
      var s = document.createElement('p'); s.className = 'pequeno';
      s.textContent = 'Fecha de registro: ' + (r.fecha || fechaLima()) + '. Guarda el número: con él consultas tu caso. Respondemos en un plazo no mayor a quince (15) días hábiles.';
      caja.appendChild(t); caja.appendChild(s);
      form.replaceChildren(caja);
      caja.focus();
    };

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      limpiar();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      boton.classList.add('boton--cargando'); boton.disabled = true; boton.setAttribute('aria-busy', 'true');
      fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(datos()) })
        .then(function (res) { return res.json().catch(function () { return {}; }).then(function (r) { return { ok: res.ok, status: res.status, r: r }; }); })
        .then(function (x) {
          if (x.ok && x.r.codigo) { exito(x.r); return; }
          var primero = null;
          Object.keys(x.r.errores || {}).forEach(function (k) { var c = marcar(k, x.r.errores[k]); if (!primero) primero = c; });
          if (x.status === 429) avisar('Recibimos varias hojas seguidas desde tu conexión. Espera unos minutos y vuelve a enviar.');
          else if (primero) { avisar('Revisa los campos marcados y vuelve a enviar.'); primero.focus(); }
          else avisar(x.r.mensaje || 'No pudimos registrar tu hoja. Intenta de nuevo en unos minutos o escríbenos por WhatsApp.');
        })
        .catch(function () { avisar('Sin conexión. Tu hoja todavía no se registró: revisa tu internet y vuelve a enviar.'); })
        .finally(function () { if (boton.isConnected) { boton.classList.remove('boton--cargando'); boton.disabled = false; boton.removeAttribute('aria-busy'); } });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
